$(function () {
	'use strict';

	initFilter();

	//クエリ取得
	/* var q = location.search.substring(1);
	if (q) {
		var p = q.split('&');
		if (p != '') {
			for (var i = 0; i < p.length; i++) {
				if (p[i].indexOf('page=') != -1) {

					setTimeout(function () {
						$('html, body').scrollTop($('#mainArea').offset().top);
					});
					break;
				}
			}
		}
	} */


});

function initFilter() {
	setFilter();

	$('.searchBar .filter .options img, .proSize .filter .options img').click(function () {
		var filter = $(this).parents('.filter');
		var lable = filter.find('.lable');
		var options = filter.find('.options');
		options.stop(true).slideUp();

		if (lable.hasClass('hasList')) {
			lable.removeClass('hasList');
		} else {
			lable.addClass('hasList');
		}
	});

}

function setFilter() {

	var breakpoint = 768;
	var winWidth, isSp, isiPad
	winWidth = $(window).width();
	if (winWidth <= breakpoint) {
		isSp = isiPad = true;
	} else {
		isSp = isiPad = false;
	}

	//if (isSp || isiPad) {
	$('.searchBar .filter, .searchBar .option, .proSizeInfo .option').unbind('hover');

	$('.searchBar .filter .lable, .proSize .filter .lable').click(function () {
		if ($(this).hasClass('hasList')) {
			$(this).removeClass('hasList');
		} else {
			$(this).addClass('hasList');
		}

		$(this).next('.options').stop(true).slideToggle(function () {
			$(this).css('overflow', '');
		});

		$(this).parents('.filter').siblings().find('.options').hide();

		if ($(this).parents().parents().hasClass('searchBar')) {
			//alert('searchBar');
			$('.proSize').find('.options').slideUp();
		} else {
//alert('proSize');
			$('.searchBar').find('.options').slideUp();
		}

		$(this).parents('.filter').siblings().find('.lable').removeClass('hasList');
		$('.searchBar').removeClass('onMore');
	});

	$('.searchBar .option p').click(function () {
		$(this).next('ul').stop(true).slideToggle();
		if (isiPad) $(this).parents('.option').siblings().find('ul').slideUp();
	});
	//} else {
	//$('.searchBar .filter .lable, .searchBar .option p, .proSizeInfo .option p').unbind('click');
	//$('.searchBar .filter, .searchBar .option, .proSizeInfo .option').unbind('hover');

	//$('.searchBar .filter .lable').removeClass('hasList');
	//$('.searchBar .options, .searchBar .options ul, .proSizeInfo .options ul').hide();

	//$('.searchBar .filter, .proSizeInfo .filter').hover(function () {
	//$('.searchBar .filter .lable, .proSize .filter .lable').click(function () {
	//	$(this).find('.options').stop(true).slideToggle(function () {
	//		$(this).css('overflow', '');
	//	});
	//});

	//$('.searchBar .option').hover(function () {
	//	$(this).find('ul').stop(true).slideToggle();
	//});
	//}
}






